/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Double-tap a product photo on touch screens to open the fullscreen zoom (same as the "+" button)
(function () {
  var lastTap = 0, startX = 0, startY = 0, moved = false;

  document.addEventListener('touchstart', function (event) {
    if (event.touches.length !== 1) { moved = true; return; }
    moved = false;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    var touch = event.touches[0];
    if (event.touches.length !== 1 || Math.abs(touch.clientX - startX) > 10 || Math.abs(touch.clientY - startY) > 10) {
      moved = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    var slide = event.target.closest('.Product__Slideshow--zoomable .Product__SlideItem--image');
    if (!slide || moved) { lastTap = 0; return; }

    var now = Date.now();
    if (now - lastTap < 300) {
      var zoomButton = slide.closest('.Product').querySelector('[data-action="open-product-zoom"]');
      if (zoomButton) { zoomButton.click(); }
      lastTap = 0;
    } else {
      lastTap = now;
    }
  });
})();

// Sticky add-to-cart bar on mobile product pages: shows once the main Add to Cart button is scrolled past
(function () {
  var bar = document.querySelector('[data-product-sticky-bar]');
  var mainButton = document.querySelector('.ProductForm .ProductForm__AddToCart');
  if (!bar || !mainButton || !('IntersectionObserver' in window)) { return; }

  new IntersectionObserver(function (entries) {
    var entry = entries[0];
    var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    document.documentElement.style.setProperty('--sticky-bar-height', bar.offsetHeight + 'px');
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('has-sticky-bar', show);
  }).observe(mainButton);

  bar.querySelector('[data-sticky-add-to-cart]').addEventListener('click', function () {
    mainButton.click();
  });

  // Thumbnail and title scroll back up to the product title and description
  var productMeta = document.querySelector('.ProductMeta');
  bar.querySelector('[data-sticky-back]').addEventListener('click', function () {
    if (!productMeta) { return; }
    var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height')) || 0;
    window.scrollTo({ top: productMeta.getBoundingClientRect().top + window.pageYOffset - headerHeight - 16, behavior: 'smooth' });
  });
})();
